import { render, staticRenderFns } from "./MinhaRespostaDadosBasicos.vue?vue&type=template&id=73a707ad"
import script from "./MinhaRespostaDadosBasicos.vue?vue&type=script&lang=js"
export * from "./MinhaRespostaDadosBasicos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports